import styled, { css } from 'styled-components';

const StyledButton = styled.button`
  min-width: 192px;
  min-height: 52px;

  padding-left: 16px;
  padding-right: 16px;
  
  border: none;
  background: #C61F0C;
  border-radius: 26px;

  font-family: 'LatoBold';
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;

  &:disabled {
    opacity: 0.5;
  }

  ${({ secondary }) => secondary && css`
    background: #FFFFFF;
    border: 1px solid #078FF1;
    color: #078FF1;

    &:hover {
      background: #078FF1;
      color: #FFFFFF;
    }
  `}

  ${({ small }) => small && css`
      min-width: unset;
      min-height: 42px;
  `}

  ${({ color }) => color && css`
      background: ${color};
  `}
`;

export default StyledButton;
